import { createContext, useContext, useEffect, useRef } from 'react';

// Lets the wizard inside a BulkUploadDialog see a backdrop click or Escape
// before the dialog closes. Without it those two exits skipped every warning
// the wizard's own Close button gives. Kept apart from BulkUploadDialog so a
// test that mocks the dialog still gets a working (no-op) hook.
export const BulkUploadDialogCloseContext = createContext(null);

/**
 * Registers `intercept` for the enclosing dialog's backdrop click and Escape
 * while the caller is mounted. Returning true keeps the dialog open (the caller
 * is asking the teacher first); anything else lets it close as before. A no-op
 * outside a BulkUploadDialog: the page frame has no backdrop to click.
 */
export const useBulkUploadDialogClose = (intercept) => {
  const interceptRef = useContext(BulkUploadDialogCloseContext);
  const latest = useRef(intercept);
  latest.current = intercept;
  useEffect(() => {
    if (!interceptRef) return undefined;
    const handler = () => latest.current?.();
    interceptRef.current = handler;
    return () => {
      if (interceptRef.current === handler) interceptRef.current = null;
    };
  }, [interceptRef]);
};
